<!-- @veltra/icons generated sha256:0a42b9fcf3a20fd4 gen:8 source:src/svg/normal/delete.svg -->
<script setup lang="ts">
defineOptions({ name: 'Delete' })
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.333"
    viewBox="0 0 24 24"
  >
    <path d="M3 6h18m-2 0v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6m3 0V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
  </svg>
</template>
